import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPersonalDataConfirm = loadable(
  () => import('./PersonalDataConfirm'),
  {
    fallback: <Loader />,
  },
);
